interface PlayerMismatchNoteProps {
  title: string;
  artist: string;
  acknowledged: boolean;
  onAcknowledge: () => void;
}

export function PlayerMismatchNote({ title, artist, acknowledged, onAcknowledge }: PlayerMismatchNoteProps) {
  const label = `Bridge: ${title} – ${artist}`;
  const stateClasses = acknowledged
    ? 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 cursor-default'
    : 'bg-red-600 text-white motion-safe:animate-pulse hover:bg-red-700';

  return (
    <button
      type="button"
      onClick={acknowledged ? undefined : onAcknowledge}
      disabled={acknowledged}
      title={label}
      aria-label={
        acknowledged
          ? `Bridge heard ${title} by ${artist}. Acknowledged.`
          : `Bridge heard ${title} by ${artist}. Tap to acknowledge.`
      }
      data-testid="player-mismatch-note"
      className={`max-w-xs truncate text-xs px-2 py-1 rounded-md font-medium ${stateClasses}`}
    >
      {label}
    </button>
  );
}
